export class UserInfo {
    static getParamsFromUrl() {
        const search = new URLSearchParams(window.location.search);
        let seamlessToken = "";
        let playerId = "";
        let brandId = "";
        const entries = search.entries();
        for (let pair of entries) {
            var keyToLower = pair[0].toLowerCase();
            if (keyToLower.indexOf("stoken") === 0 || keyToLower.indexOf("token") === 0) {
                seamlessToken = pair[1];
            }
            else if (keyToLower.indexOf("playerid") === 0) {
                playerId = pair[1];
            }
            else if (keyToLower.indexOf("brandid") === 0) {
                brandId = pair[1];
            }
        }
        return {
            seamlessToken,
            playerId,
            brandId
        };
    }
}
UserInfo.onLogin = {};
UserInfo.onLogout = {};
UserInfo.onNotLoggedIn = {};
UserInfo.onLoginFailed = {};
UserInfo.onLoginSucceed = {};
UserInfo.onDataUpdated = {}; //triggered when user information is loaded/updated
UserInfo.onUpdateBalance = {}; //triggered when balance is loaded/updated
UserInfo.onGetBalance = {}; //triggered when balance and open bets are loaded/updated
UserInfo.onLimitationsDataUpdated = {};
UserInfo.onCaptcha = {};
UserInfo.onTokenLogin = {};
UserInfo.onTwoStepLogin = {};
UserInfo.onTwoStepLoginContinue = {};
UserInfo.OnTwoStepNativeLogin = {};
UserInfo.onAcceptOddsChanged = {};
UserInfo.onTokenLoginReceived = {};
UserInfo.onOneTimeTokenReceived = {};
UserInfo.onOneTimeTokenLoginFailed = {};
UserInfo.onSessionKeepAlive = {};
UserInfo.onJwtLoginReceived = {};
UserInfo.onSecondStepLoginFailed = {};
//# sourceMappingURL=UserInfo.js.map